import { useCallback, useEffect, useState } from 'react';

import { api } from '../../../services';

// Etapa 5: só leitura. Sem polling contínuo — o usuário troca de mês/ano ou
// reabre a tela pra atualizar (Reingerir/Gerar pacote chegam na Etapa 7,
// junto de um refresh automático depois da ação).
function useCalendarioFiscal(ano, mes) {
  const [dados, setDados] = useState(null);
  const [carregando, setCarregando] = useState(false);
  const [versao, setVersao] = useState(0);

  useEffect(() => {
    let cancelado = false;

    async function buscar() {
      setCarregando(true);
      try {
        const response = await api.get(
          `/relatorios_fiscais_calendario/${ano}/${mes}`,
        );
        if (!cancelado) setDados(response.data.data);
      } finally {
        if (!cancelado) setCarregando(false);
      }
    }

    buscar();

    return () => {
      cancelado = true;
    };
  }, [ano, mes, versao]);

  const recarregar = useCallback(() => setVersao((atual) => atual + 1), []);

  return { dados, carregando, recarregar };
}

export default useCalendarioFiscal;
